(function () {

  'use strict';

  function pxGroupListContextMenu(
    $timeout, $window
  ) {
    return {
      restrict: 'E',
      scope: {
        context: '=context',
        resource: '=resource',
        selectedTab: '=selectedTab',
        contextPosition: '=contextPosition',
        callback: '&callback',
        updateParent: '&updateParent'
      },

      templateUrl: 'app/components/groupList/_groupListContextMenu/groupListContextMenu.template.html',
      link: function (scope, element, attrs) {

        (function () {
          initContexContent();
        })();

        scope.$watch(function () {
          return scope.contextPosition;
        }, function (oldVal, newVal) {
          if (oldVal !== newVal) {
            initContexContent();
          }
        });

        function initContexContent() {
          centerMenu();
        }

        function centerMenu() {
          $timeout(function () {
            const menu = angular.element('.context-content-container');
            const left = ($window.innerWidth - menu.innerWidth()) / 2;
            const top = ($window.innerHeight - menu.innerHeight()) / 2;
            menu.css({ left, top, display: 'block' });
          }, 50);
        }

        scope.closePopup = function (bypass) {
          if (!bypass) {
            scope.callback({ selectedContextMenuItem: null, contextPosition: null, contextContent: null });
          }
        };

        scope.relayUpdateParent = function () {
          scope.updateParent();
        };

        scope.$on('$destroy', function () {
          angular.element('.context-content-container').css({ display: 'none' });
        });

      }
    };
  }

  pxGroupListContextMenu.$inject = ['$timeout', '$window'];

  angular
    .module('printix-admin')
    .directive('pxGroupListContextMenu', pxGroupListContextMenu);

})();
